module.exports = __webpack_public_path__ + "static/our_business03-390233e74470c939063847a9dc6cacd4.jpg";